export function splitWithTail(str: string, delim: string, count?: number) {
    let parts = str.split(delim);
    let tail = parts.slice(count).join(delim);
    let result = parts.slice(0, count);
    result.push(tail);
    return result;
}

export default splitWithTail
